import { ProfessionalHeadingCtas } from './ProfessionalHeadingCtas';

/**
 * About tab intro (Figma 2354:58864) — a big "About us" heading with the shared
 * {@link ProfessionalHeadingCtas} cluster (typical project value + Get in touch
 * / Visit Website / Save) on the right. Desktop only: on mobile it's redundant
 * with the "About" tab pill + the persistent header CTAs, so it's hidden below
 * md.
 */
export const ProfessionalAboutIntroSection = () => {
    return (
        <section className="w-full overflow-hidden bg-white text-[#1f1f21] max-md:hidden md:px-[3.125rem] md:pt-[3rem] md:pb-[1.875rem]">
            <div className="mx-auto w-full max-w-[113.75rem]">
                <div className="flex md:items-start md:justify-between">
                    <h2 className="m-0 font-sans font-normal text-[#141414] md:text-[12.5rem] md:leading-[11.25rem] md:tracking-[-0.525rem]">
                        About us
                    </h2>

                    <ProfessionalHeadingCtas />
                </div>
            </div>
        </section>
    );
};
